import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { registerAction2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { CommandsRegistry } from 'vscode/vscode/vs/platform/commands/common/commands';
import { Extensions as Extensions$2 } from 'vscode/vscode/vs/platform/jsonschemas/common/jsonContributionRegistry';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Extensions } from 'vscode/vscode/vs/workbench/common/contributions';
import { ConfigureSnippetsAction } from './commands/configureSnippets.js';
import { ApplyFileSnippetAction } from 'vscode/vscode/vs/workbench/contrib/snippets/browser/commands/fileTemplateSnippets';
import { InsertSnippetAction } from './commands/insertSnippet.js';
import { SurroundWithSnippetEditorAction } from './commands/surroundWithSnippet.js';
import { SnippetCodeActions } from './snippetCodeActionProvider.js';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import 'vscode/vscode/vs/workbench/contrib/snippets/browser/snippetsService';
import { Extensions as Extensions$1 } from 'vscode/vscode/vs/platform/configuration/common/configurationRegistry';
import 'vscode/vscode/vs/workbench/contrib/snippets/browser/tabCompletion';
import { editorConfigurationBaseNode } from 'vscode/vscode/vs/editor/common/config/editorConfigurationSchema';

const _moduleId = "vs/workbench/contrib/snippets/browser/snippets.contribution";
registerAction2(InsertSnippetAction);
CommandsRegistry.registerCommandAlias('editor.action.showSnippets', 'editor.action.insertSnippet');
registerAction2(SurroundWithSnippetEditorAction);
registerAction2(ApplyFileSnippetAction);
registerAction2(ConfigureSnippetsAction);
const workbenchContribRegistry = ( (Registry.as(Extensions.Workbench)));
workbenchContribRegistry.registerWorkbenchContribution(SnippetCodeActions, 3 );
( (Registry
    .as(Extensions$1.Configuration)))
    .registerConfiguration({
    ...editorConfigurationBaseNode,
    'properties': {
        'editor.snippets.codeActions.enabled': {
            'description': ( localizeWithPath(
                _moduleId,
                0,
                'Controls if surround-with-snippets or file template snippets show as Code Actions.'
            )),
            'type': 'boolean',
            'default': true
        }
    }
});
const languageScopeSchemaId = 'vscode://schemas/snippets';
const snippetSchemaProperties = {
    prefix: {
        description: ( localizeWithPath(
            _moduleId,
            1,
            'The prefix to use when selecting the snippet in intellisense'
        )),
        type: ['string', 'array']
    },
    isFileTemplate: {
        description: ( localizeWithPath(_moduleId, 2, 'The snippet is meant to populate or replace a whole file')),
        type: 'boolean'
    },
    body: {
        markdownDescription: ( localizeWithPath(
            _moduleId,
            3,
            'The snippet content. Use `$1`, `${1:defaultText}` to define cursor positions, use `$0` for the final cursor position. Insert variable values with `${varName}` and `${varName:defaultText}`, e.g. `This is file: $TM_FILENAME`.'
        )),
        type: ['string', 'array'],
        items: {
            type: 'string'
        }
    },
    description: {
        description: ( localizeWithPath(_moduleId, 4, 'The snippet description.')),
        type: ['string', 'array']
    }
};
const languageScopeSchema = {
    id: languageScopeSchemaId,
    allowComments: true,
    allowTrailingCommas: true,
    defaultSnippets: [{
            label: ( localizeWithPath(_moduleId, 5, "Empty snippet")),
            body: { '${1:snippetName}': { 'prefix': '${2:prefix}', 'body': '${3:snippet}', 'description': '${4:description}' } }
        }],
    type: 'object',
    description: ( localizeWithPath(_moduleId, 6, 'User snippet configuration')),
    additionalProperties: {
        type: 'object',
        required: ['body'],
        properties: snippetSchemaProperties,
        additionalProperties: false
    }
};
const globalSchemaId = 'vscode://schemas/global-snippets';
const globalSchema = {
    id: globalSchemaId,
    allowComments: true,
    allowTrailingCommas: true,
    defaultSnippets: [{
            label: ( localizeWithPath(_moduleId, 5, "Empty snippet")),
            body: { '${1:snippetName}': { 'scope': '${2:scope}', 'prefix': '${3:prefix}', 'body': '${4:snippet}', 'description': '${5:description}' } }
        }],
    type: 'object',
    description: ( localizeWithPath(_moduleId, 6, 'User snippet configuration')),
    additionalProperties: {
        type: 'object',
        required: ['body'],
        properties: {
            ...snippetSchemaProperties,
            scope: {
                description: ( localizeWithPath(
                    _moduleId,
                    7,
                    "A list of language names to which this snippet applies, e.g. 'typescript,javascript'."
                )),
                type: 'string'
            }
        },
        additionalProperties: false
    }
};
const reg = ( (Registry.as(Extensions$2.JSONContribution)));
reg.registerSchema(languageScopeSchemaId, languageScopeSchema);
reg.registerSchema(globalSchemaId, globalSchema);
